// angular
import { Component, HostListener, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import {of as observableOf,  Observable ,  Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

// others
import { AppService } from '../app.service';
import { AuthService } from '../core/auth.service';
import { CoreService } from '../core/core.service';
import { KlenicoMeService } from './me.service';
import { finalize } from 'rxjs/operators';
import { DialogComponent } from '../dialog/dialog.component';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { FormGroup } from '@angular/forms';
import * as _ from 'lodash';

@Component({
    selector: 'me-app',
    templateUrl: './me.component.html',
    styleUrls: ['./me.component.scss'],
    providers: [KlenicoMeService],
    encapsulation: ViewEncapsulation.None
})

export class MeComponent implements OnInit {
    @ViewChild('dialog',  { static: false}) dialog: DialogComponent;
    // for addition/update/details modal
    @ViewChild('modal',  {static: false}) modal: ModalDirective;

    sub: Subscription;
    modalHidingSub: Subscription;
    data: any;
    modalIsClosed = false;
    form: FormGroup;
    errorMessage: string[] = [];
    errorData: any;
    responseMessage: string;
    languageLocale: string;
    language: any;
    languages: Object[] = this.appService.meLanguages;
    roles: Object[] = [];
    clinics: Object[] = [];
    token: string;
    formLoading = true;
    formSubmitted: boolean;
    url: string;
    // query parameters
    params: Object = {};
    // will be removed after integrate changes into clinics,profiles,...
    formAction: string;
    isUpdated = true;

    // handle app loading icon
    get isLoading() {
        return this.appService.isLoading;
    }

    set isLoading(isLoading) {
        this.appService.isLoading = isLoading;
    }

    constructor(
        public appService: AppService,
        public translate: TranslateService,
        public coreService : CoreService,
        public router: Router,
        public meService: KlenicoMeService,
        public authService: AuthService
    ) {
       
    }

    ngOnInit() {
        this.languageLocale = this.appService.getLanguage() || this.translate.currentLang;
        const user = this.authService.user;
        if(user?.language?.locale){
            this.appService.setLanguage(user?.language?.locale);
        }
    }

    handleResponse(response: any): void {
        this.isUpdated = true;
        if (response['message']) {
            this.responseMessage = response['message'];
            return;
        }
    }

    initForm(params: Object, navigate = true): void {
        this.params = params;
        // store the current page to be used later since this.currentPage will be set to 1 when opening the modal
        let queryParams = {};

        for (const param in this.params) {
            if (param !== 'url' && this.params.hasOwnProperty(param)) {
                queryParams[param] = this.params[param];
            }
        }

        // reset errors
        this.resetErrors();

        if (navigate) {
            // Notice: For popup navitation from the search on StartPage
            this.router.navigate([this.params['url']], { queryParams: queryParams });
        }

        // display app loading icon
        this.isLoading = true;
    }

    resetErrors() {
        if (this.errorMessage.length > 0) {
            this.errorMessage = [];
        }
    }

    // user addition/update handler: send user info to DB
    submit(model: any, isValid: boolean, url?: string, isUpdated?: boolean): void {
        if (url == null) {
            url = this.url;
        }

        this.resetErrors();
        // this ensures validation messages will only be displayed when necessary
        this.formSubmitted = true;
        // only when the form is valid and its values have been changed
        if (isValid) {
            this.isLoading = true;

            this.meService.submit(url, this.params['id'], model).pipe(
                finalize(() => {
                    this.isLoading = false;
                }))
                .subscribe(
                    response => {
                        this.handleResponse(response);
                        // hide addition modal
                        if (isUpdated) {
                        } else {
                        }
                    },
                    error => {
                        this.isLoading = false;
                        this.errorMessage = this.appService.parseErrors(error);
                        this.errorData = error?.error?.data || '';
                    }
                );
        }
    }

    // display modal
    showModal(): void {
        // prevent users from clicking outside to close the modal since that does not set the url correctly
        this.modal.config.backdrop = false;
        this.modal.config.ignoreBackdropClick = true;
        this.modal.config.keyboard = false;
        // hide the app loading icon
        this.isLoading = false;
        this.isUpdated = false;
        this.resetErrors();
        this.modal.show();
    }

    hideModal() {
        if (this.sub) {
            this.sub.unsubscribe();
        }
        if(this?.modal?.isShown){
            this.modal.hide();
        }
        if(this.responseMessage){
            this.responseMessage = '';
        }
    }

    getContent() {
        this.appService.getStoryBlokDataForClinic(this.url).subscribe(res => {
            this.data = res['story']['content'] ?? [];
            this.appService.isLoading = false;
        });
    }
}
